import React from "react";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";

const FileDropZone = ({
  onBrowse,
  onDrop,
  onDragOver,
  fileInputRef,
  onFileChange,
}) => {
  return (
    <div className="mt-6">
      <label className="flex justify-between items-center text-sm text-gray-600 mb-2">
        Upload rubric file (.xls, .xlsx)
        <a
          href="/sample-rubric-template.xlsx"
          download
          className="inline-flex items-center gap-2 text-sm text-blue-600 underline hover:text-blue-800"
        >
          Download Sample Rubric Template
        </a>
      </label>

      <div
        className="flex items-center justify-between border rounded-lg p-4 bg-white shadow-sm border-gray-200"
        role="button"
        onDrop={onDrop}
        onDragOver={onDragOver}
      >
        <div className="flex items-center space-x-4">
          <div className="p-2 bg-gray-100 rounded-md">
            <CloudArrowUpIcon className="w-6 h-6 text-gray-500" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-900">
              Drag and drop Excel file here
            </p>
            <p className="text-xs text-gray-500">Limit 200MB • XLS, XLSX</p>
          </div>
        </div>

        <button
          type="button"
          onClick={onBrowse}
          className="px-3 py-2 border rounded-md text-sm hover:bg-gray-50"
        >
          Browse files
        </button>

        <input
          ref={fileInputRef}
          type="file"
          accept=".xls,.xlsx"
          className="hidden"
          onChange={onFileChange}
        />
      </div>
    </div>
  );
};

export default FileDropZone;
